<template>
  <Container class="my-12 w-full px-0 md:px-6">
    <figure class="lg:py-12">
      <div
        ref="container"
        class="keen-slider md:rounded-3xl">
        <div
          v-for="(item, index) in slides"
          :key="index"
          class="mx-auto">
          <div
            v-if="item.asset.endsWith('mp4')"
            class="keen-slider__slide">
            <SectionVideo :video-source="item.asset" />
          </div>
          <div
            v-else
            class="keen-slider__slide h-full w-full md:max-h-[641.25px]">
            <NuxtImg
              :src="item.asset"
              :alt="item.caption || ''"
              class="mx-auto max-h-full max-w-full max-md:w-full md:rounded-3xl"
              sizes="xs:100vw sm:746px md:984px lg:1240px xl:1440px xxl:1440px"
              loading="lazy" />
          </div>
        </div>
      </div>
      <div
        v-if="slides.length > 1 || slides.some(slide => slide.caption && slide.caption.length > 0)"
        class="mt-6 flex flex-col items-center px-6 md:justify-between">
        <div
          v-if="slider && slider.track.details.slides.length > 1"
          class="relative mb-4 flex w-32 flex-shrink-0 items-center justify-center">
          <button
            class="absolute left-0 select-none rounded-md p-2 hover:bg-gray-100"
            @click="slider.prev()">
            <span class="sr-only">Previous</span>
            <IconArrowRight class="h-4 w-4 rotate-180" />
          </button>

          <div class="flex px-4 tabular-nums">{{ current + 1 }} - {{ slider.track.details.slides.length }}</div>

          <button
            class="absolute right-0 select-none rounded-md p-2 hover:bg-gray-100"
            @click="slider.next()">
            <span class="sr-only">Next</span>
            <IconArrowRight class="h-4 w-4" />
          </button>
        </div>
        <!-- if all captions are empty, do not show -->
        <figcaption
          v-if="!slides.every(slide => slide.caption === '')"
          class="text-center">
          {{ slides[current].caption }}
        </figcaption>
      </div>
    </figure>
  </Container>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue'

  import { type KeenSliderInstance, useKeenSlider } from 'keen-slider/vue.es'

  type BlogSliderType = {
    slides: {
      asset: string
      caption: string
      type: string
    }[]
  }

  defineProps<BlogSliderType>()

  const current = ref(0)

  const update = (e: KeenSliderInstance) => {
    current.value = e.track.details.rel
  }

  onMounted(async () => {
    // temporary fix for route change bug
    setTimeout(() => {
      if (slider.value) {
        slider.value.update()
      }
    }, 200)
  })

  const [container, slider] = useKeenSlider({
    slides: {
      perView: 1
    },
    loop: true,
    slideChanged: e => update(e)
  })
</script>
